/* eslint-disable import/prefer-default-export */
export const mapClubMemberV2ToV1 = (member, clubId) => {
    const memberV2 = member.source;
    // eslint-disable-next-line eqeqeq
    const club = memberV2.clubMemberships?.find(c => c.clubId == clubId);
    const memberV1 = {
        ...memberV2,
        clubMemberRoleId: club.roleId,
        intialJoinDate: club.intialJoinDate,
        role: club.roleValue,
        clubMemberTypeId: club.typeId,
        isPower: club.isPower,
        location: (memberV2.location ? (memberV2.location.display || '') : ''),
        playerId: memberV2.id,
    };
    return memberV1;
};
